import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MeetingsStatisticsAPI from '../../../api/MeetingsStatisticsAPI';
import BarChart from '../../../components/BarChart/BarChart';
import NoData from '../../../components/NoData/NoData';

type Props = { timeRange: { start: string; end: string } };

function BookingsTypeDistribution({ timeRange }: Props) {
  const { t } = useTranslation();
  const [labels, setLabels] = useState<string[]>([]);
  const [values, setValues] = useState<number[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await MeetingsStatisticsAPI.getBookingsTypeDistribution({ startTime: timeRange.start, endTime: timeRange.end });
        const rawLabels = res.data?.labels || [];
        setLabels(rawLabels);
        setValues(res.data?.values || []);
      } catch (e) {
        setLabels([]);
        setValues([]);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end, t]);

  if (!labels.length) return <NoData message={t('global.empty_results')} />;

  return (
    <BarChart
      title={t('stats.bookings_type_distribution') || 'Bookings type %'}
      xLabels={labels}
      dataSets={[{
        label: t('stats.bookings') || 'Bookings',
        data: values,
        backgroundColor: ['rgba(14, 165, 233, 0.6)'],
        borderColor: ['rgba(14, 165, 233, 0.6)'],
        borderWidth: 1,
      }]}
    />
  );
}

export default BookingsTypeDistribution;


